<script lang="ts">
  import Button from '$lib/components/ui/button/button.svelte';
  import { toast } from 'svelte-sonner';

  let { deactivateAccountOpen = $bindable(), user, experience } = $props();

  let loading = $state(false);

  function handleDeleteAccount() {
    // Emit accountUpdate event with type 'delete'
    if (experience?.eventHub) {
      loading = true;
      toast.info('Deleting User...');
      experience.eventHub.emit('accountUpdate', {
        type: 'delete',
        data: {
          userId: user?.id || user?.sub,
        },
      });
    } else {
      toast.error('Unable to delete account - event system not available');
    }
  }

  // Listen for accountUpdate response to update loading state
  $effect(() => {
    if (experience?.eventHub) {
      const handleUpdateComplete = (success: boolean) => {
        loading = false;
        if (success) {
          deactivateAccountOpen = false;
          toast.success('Account deleted successfully!');
        } else {
          toast.error('There was an error while trying to delete user!');
        }
      };

      experience.eventHub.on('accountUpdate:delete:complete', handleUpdateComplete);

      return () => {
        experience.eventHub.off('accountUpdate:delete:complete', handleUpdateComplete);
      };
    }
  });
</script>

<div class=" flex !flex-col overflow-hidden !px-4 pb-4 max-h-[450px] h-[350px]">
  <div class="flex-1 overflow-y-auto pr-1 w-full text-sm !px-4">
    <p class="">
      Deleting your account will permanently erase all of your data from our
      system, and you will no longer be able to access your profile, Quote
      Requests, or any other content associated with your account. This action
      is permanent and cannot be undone. Deleting account will do following:
    </p>

    <p>- Log you out on all devices</p>
    <p>- Delete all your account information.</p>

    <p class="!mt-4">
      On the other hand, deactivating your account will temporarily suspend your
      account and remove your profile and content. However, your data will
      remain stored in our system and can be reactivated at any time by logging
      back in to your account.
    </p>

    <p class="!mt-4">
      If you are unsure about whether to delete or deactivate your account, we
      recommend deactivating your account first. This will allow you to take a
      break from our platform without losing your data or having to create a new
      account if you decide to come back later. However, if you are certain that
      you want to permanently delete your account, please select the 'Delete
      Account' option.
    </p>
  </div>
  <div class="flex justify-between gap-2 mt-4 shrink-0 w-full">
    <div>
      <Button
        variant="outline"
        onclick={() => (deactivateAccountOpen = false)}
        class={` h-9 !px-4 !py-6 border-2 border-[#DADADA] !shadow-none  !text-sm font-normal hover:brightness-110 transition`}
        >Back to account</Button
      >
    </div>

    <div>
      <Button
        variant="outline"
        disabled={loading}
        onclick={() => handleDeleteAccount()}
        class={` h-9 !px-4 !py-6 border-2 border-[#DADADA] !shadow-none  !text-sm font-normal hover:brightness-110 transition`}
        style={`background-color: #DADADA`}>Delete Account</Button
      >
      <Button
        type="submit"
        disabled={true}
        onclick={() => handleDeleteAccount()}
        class={` h-9 !px-4 !py-6 border-none !shadow-none  !text-sm font-normal hover:brightness-110 transition text-white !bg-[#004976] dark:!bg-[var(--theme-link)]`}>Deactivate Account</Button
      >
    </div>
  </div>
</div>
